import printJS from 'print-js-updated';
import { error as errorToast } from '@/plugins/toast';

class HttpFile {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }

  link(route, params = {}, options = {}) {
    options = {
      method: 'GET',
      ...options,
    };

    if (!route) {
      return Promise.reject(new Error('Invalid url'));
    }

    return this.httpClient.get('/download-token')
      .then(({ data }) => (
        this.httpClient.getUri({
          url: route,
          params: options.method.toUpperCase() === 'POST' ? data : { ...params, ...data },
        })
      ));
  }

  async download(route, params = {}, options = {}) {
    options = {
      method: 'GET',
      name: null,
      ...options,
    };

    const isBlob = options.method.toUpperCase() === 'POST';

    const linkParams = {
      ...(params || {}),
      attachment: options.name || true,
    };
    const url = await this.link(route, linkParams, options);

    const linkEl = document.createElement('a');
    linkEl.type = 'hidden';
    linkEl.href = url;

    if (isBlob) {
      const { data } = await this.httpClient.post(url, params, {
        responseType: 'blob',
      });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(data);
        return;
      }

      linkEl.href = URL.createObjectURL(data);
    }

    if (options.name) {
      linkEl.download = options.name;
    }

    // Append a link to the body
    document.body.appendChild(linkEl);

    // this is necessary as linkEl.click() does not work on the latest firefox
    linkEl.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      }),
    );

    setTimeout(() => {
      if (isBlob) {
        // For Firefox, it is necessary to delay revoking the ObjectURL
        URL.revokeObjectURL(linkEl.href);
      }
      document.body.removeChild(linkEl);
    }, 100);
  }

  print(route, params = {}, options = {}) {
    options = {
      method: 'GET',
      ...options,
    };

    return this.link(route, params, options)
      .then(url => (
        options.method.toUpperCase() === 'POST'
          ? this.httpClient.post(url, params, { responseType: 'arraybuffer' })
          : this.httpClient.get(url, { responseType: 'arraybuffer' })
      ))
      .then(({ data }) => new Promise((resolve) => {
        printJS({
          printable: Buffer.from(data, 'binary').toString('base64'),
          type: 'pdf',
          onLoadingStart: () => {},
          onLoadingEnd: resolve,
          onError: HttpFile.errorHandler,
          base64: true,
        });
      }))
      .catch(HttpFile.errorHandler);
  }

  static errorHandler(e) {
    const message = typeof e === 'string' && e.toUpperCase() === 'FORBIDDEN'
      ? 'Acesso negado'
      : e;
    errorToast(message, { timeout: 7000 });
  }
}

export default HttpFile;
